import { fetchApi } from "./utils";

/**
 * Get authentified user
 */
export const getUser = async () => fetchApi("/users/me", { method: "GET" });

/**
 * Update authentified user
 */
export const updateUser = params =>
  fetchApi("/users/me", { method: "PUT", params: { ...params } });

/**
 * Delete current user
 */
export const deleteUser = () => fetchApi("/users/me", { method: "DELETE" });
